import React, { FunctionComponent, useState } from "react";
import {
  DialogContent,
  DialogContentText,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";

export interface UserManagementWarningComponentProps {
  agreedValue: boolean;
  onAgreedChange: (agreed: boolean) => void;
}

const UserManagementWarningComponent: FunctionComponent<
  UserManagementWarningComponentProps
> = ({ agreedValue, onAgreedChange }) => {
  const [agreed, setAgreed] = useState(agreedValue);
  const toggleCheckbox = () => {
    setAgreed(!agreed);
    onAgreedChange(!agreed);
  };

  return (
    <div>
      <DialogContent>
        <DialogContentText>
          By checking the box below, I acknowledge that I am activating my
          account, and by my activation of the account, I agree and further
          certify that I possess the requisite authority to execute this
          document on behalf of my institution (“User”). I understand that
          Baylor Miraca Genetics Laboratory (BG) has agreed to allow (“User”)
          access to its online portal (“Portal”). User certifies that the unique
          email address(es) used to establish a new user's ordering provider's
          (“Provider”) access to the Portal has been assigned to the Provider by
          and is affiliated with User's institution. User certifies that it is
          legally permissible in Provider's jurisdiction for Provider to order
          the requested testing. User understands and warrants the NPI number
          utilized by Provider is accurate, belongs to Provider, and matches the
          ordering Provider's name, as registered with User. User certifies that
          Provider has been granted permission by User and is qualified to
          access to the portal. User understands and agrees that User is solely
          responsible for and shall immediately terminate Provider's access to
          the portal should Provider's affiliation with User terminate for any
          reason.
        </DialogContentText>
      </DialogContent>
      <div>
        <FormControlLabel
          control={
            <Checkbox
              id="agree-checkbox"
              name="agree-checkbox"
              checked={agreed}
              onChange={toggleCheckbox}
              required
            />
          }
          label="I agree to the above terms and conditions"
        />
      </div>
    </div>
  );
};

export default UserManagementWarningComponent;
